import styled from '@emotion/styled'

export const SmallContainer = styled.small`
    padding: .1875rem .5rem;
    background-color: var(--lighter-gray);
`